import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { T } from "../constants";
import { useUi } from "../styles";
import Overlay from "./Overlay";
import Panel from "./Panel";

const useStyles = makeStyles({
  card: {
    width: "100%",
    maxWidth: ({ width }) => width,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    maxHeight: "calc(100vh - 32px)",
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    padding: "18px 22px 10px",
  },
  title: { fontSize: 18, fontWeight: 700, color: T.fg },
  sub: { fontSize: 13, color: T.mutedFg, marginTop: 2 },
  body: { padding: "6px 22px 18px", overflowY: "auto" },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    padding: "12px 22px",
    borderTop: `1px solid ${T.borderSoft}`,
  },
  footerGroup: { display: "flex", gap: 8, flexWrap: "wrap" },
  close: { top: 0, right: 0 },
});

export default function ModalCard({
  title,
  subtitle,
  onClose,
  children,
  footerLeft,
  footerRight,
  width = 640,
  z = 1400,
}) {
  const s = useStyles({ width });
  const ui = useUi();

  return (
    <Overlay onClose={onClose} align="start" z={z}>
      <Panel className={s.card} role="dialog" aria-modal="true" aria-label={title}>
        <div className={s.header}>
          <div>
            <div className={s.title}>{title}</div>
            {subtitle && <div className={s.sub}>{subtitle}</div>}
          </div>
          <button
            type="button"
            className={`${ui.closeBtn} ${s.close}`}
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <div className={s.body}>{children}</div>

        {(footerLeft || footerRight) && (
          <div className={s.footer}>
            <div className={s.footerGroup}>{footerLeft}</div>
            <div className={s.footerGroup}>{footerRight}</div>
          </div>
        )}
      </Panel>
    </Overlay>
  );
}
